<template>
  <MainTab class="mx-3 mb-16"/>
</template>

<script>
import MainTab from "@/components/MainTab";
export default {
  name: "Home",
  components: {MainTab},
};
</script>